import { fetchAuthSession } from 'aws-amplify/auth';


export const getSessionIdToken = async () => {
  try {
    const session = await fetchAuthSession();
    const idToken = session?.tokens?.idToken?.toString();
    if (idToken) {
      return idToken
    }
  } catch (err) {
    console.error('Failed to get auth token');
    return undefined
  }
};

export default getSessionIdToken;